import React, { createContext, useState } from "react";

const ViewerContext = createContext();

export function ViewerProvider({ children }) {
  const [allData, setAllData] = useState({});
  const [satelliteList, setSatelliteList] = useState([]);
  const [linkChangeList, setLinkChangeList] = useState([]);
  const [dataIntervalPeriod, setDataIntervalPeriod] = useState(3);
  const [latestDataFetchTime, setLatestDateFetchTime] = useState();
  const [constellationName, setConstellationName] = useState({
    name: "Globalstar",
    id: "globalstar",
  });

  return (
    <ViewerContext.Provider
      value={{
        allData,
        setAllData,
        satelliteList,
        setSatelliteList,
        dataIntervalPeriod,
        setDataIntervalPeriod,
        latestDataFetchTime,
        setLatestDateFetchTime,
        constellationName,
        setConstellationName,
        linkChangeList,
        setLinkChangeList,
      }}
    >
      {children}
    </ViewerContext.Provider>
  );
}

export default ViewerContext;
